// Module
var code = "<div class=\"checkbox\"> <label> <input type=\"checkbox\" name=\"field_{{vm.fieldInstance.id}}\" id=\"field_{{vm.fieldInstance.id}}_{{option.id}}\" value=\"1\" ng-model=\"vm.value\"> {{ 'I_AGREE' | translate }} </label> </div> <p class=\"help-block\" ng-if=\"vm.required && vm.isEmpty\">({{ 'REQUIRED' | translate | lowercase }})</p> ";
// Exports
module.exports = code;